import axios from "axios";
import React, { Component } from "react";
import styled from "styled-components";
import { API_URL, RegionalApiManager } from "src/scenes/App";

const Page = styled.main`
    align-items: center;
    background: #f0d98a;
    color: #2a1e14;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    padding: 24px;
`;

const Card = styled.section`
    max-width: 520px;
    text-align: center;
`;

const Wordmark = styled.div`
    font-family: Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    margin-bottom: 48px;
    text-transform: uppercase;
`;

const Heading = styled.h1`
    font-family: Georgia, serif;
    font-size: 48px;
    font-weight: 400;
    line-height: 1.05;
    margin: 0 0 20px;
`;

const Body = styled.p`
    font-family: Helvetica, Arial, sans-serif;
    font-size: 18px;
    line-height: 1.5;
    margin: 0 0 32px;
`;

const AppLink = styled.a`
    background: #2a1e14;
    border-radius: 28px;
    color: #f0d98a;
    display: inline-block;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 17px;
    font-weight: 600;
    padding: 17px 28px;
    text-decoration: none;
`;

class CheckedInEmailVerificationPage extends Component {
    state = {
        status: "loading"
    };

    componentDidMount() {
        this.verifyEmail();
    }

    verifyEmail = async () => {
        const region = new URLSearchParams(window.location.search).get("region");
        const token = this.props.match.params.token;
        if (!region || !token) {
            this.setState({ status: "error" });
            return;
        }

        try {
            let regionalApiFound = true;
            await RegionalApiManager.loadRegionData(region, () => {
                regionalApiFound = false;
            });
            if (!regionalApiFound || !API_URL) {
                this.setState({ status: "error" });
                return;
            }
            await axios.post(`${API_URL}/checkedIn/auth/email/verify-link`, { token });
            this.setState({ status: "verified" });
        } catch (error) {
            console.error("Unable to verify Checked In email address.", error);
            this.setState({ status: error.response ? "expired" : "error" });
        }
    };

    renderContent() {
        if (this.state.status === "loading") {
            return (
                <>
                    <Heading>Checking your email.</Heading>
                    <Body>Please wait while we verify your Checked In account.</Body>
                </>
            );
        }
        if (this.state.status === "verified") {
            return (
                <>
                    <Heading>You&apos;re verified.</Heading>
                    <Body>Your email address is confirmed. You can return to Checked In and continue.</Body>
                    <AppLink href="https://getthecheckedinapp.com">Open Checked In</AppLink>
                </>
            );
        }
        if (this.state.status === "expired") {
            return (
                <>
                    <Heading>That link has expired.</Heading>
                    <Body>Return to Checked In and request a new verification email.</Body>
                    <AppLink href="https://getthecheckedinapp.com">Open Checked In</AppLink>
                </>
            );
        }
        return (
            <>
                <Heading>We couldn&apos;t verify your email.</Heading>
                <Body>Please try the link again. If the problem continues, request a new email in Checked In.</Body>
                <AppLink href="https://getthecheckedinapp.com">Open Checked In</AppLink>
            </>
        );
    }

    render() {
        return (
            <Page>
                <Card>
                    <Wordmark>Checked In</Wordmark>
                    {this.renderContent()}
                </Card>
            </Page>
        );
    }
}

export default CheckedInEmailVerificationPage;
